import { createReducer, on } from '@ngrx/store';
import { ProdigyActions } from './prodigy.actions';
import { ProdigyState, prodigyState } from './prodigy.state';

export const prodigyReducer = createReducer(
  prodigyState,
  on(ProdigyActions.reset, (): ProdigyState => ({ panels: [] })),
  on(
    ProdigyActions.setPanels,
    (state, { panels }): ProdigyState => ({ ...state, panels })
  )
);
